import { useContext, useEffect, useState } from "react";
import PopUp from "../PopUp";
import { useAppStore } from "../../store/useAppStore";
import Table from "../ui/Table";

export default function InventoryPopup() {
	const { glory, inventoryPopupVisible, setInventoryPopupVisible } = useAppStore();

	if (!inventoryPopupVisible) return null;

	return (
		<PopUp
			options={{
				size: "small",
				title: "Inventario Glory",
				onClose: () => setInventoryPopupVisible(false),
			}}
		>
			<div className="inner-content">
				<Table
					header={true}
					cols={[
						{ id: "type", label: "Type", type: "text" },
						{ id: "value", label: "value", type: "eur", multiply: 0.01 },
						{ id: "piece", label: "piece", type: "text", align: "center" },
						{ id: "status", label: "status", type: "inventory_status" },
					]}
					rows={JSON.parse(glory.inventory)}
				/>
			</div>
		</PopUp>
	);
}
